import truncate from "./truncate";
import formatDate from "./format-date";

export default {
  install(app) {
    app.directive("truncate", truncate);
    app.directive("format-date", formatDate);
  },
};
